import { Component } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  template: `
    <div [ngStyle]="{'visibility' : _loader.loader() ? '' : 'hidden'}"
      class="overlay position-fixed p-3 h-100 w-100 d-flex justify-content-center align-items-center"
    style="z-index:1060;">
   <div class="four-dots"></div>
  `,
})
export class LoaderComponent {
  constructor(public _loader: LoaderService) { }
}
